import { axiosNoTokenInstance } from "../../axios.config";
import { toast } from "react-toastify";

export const sendCrash = (data) => {
  axiosNoTokenInstance
    .post("crash/log", data)
    .then(() => toast.warn("Something wrong with sending logs..."))
    .catch((error) => toast.error(error.message));
};
